type GetShareUrlParams = {
  shareTitle: string;
  shareUrl: string;
};

export const getTwitterUrl = ({ shareTitle, shareUrl }: GetShareUrlParams) =>
  `http://twitter.com/share?text=${encodeURIComponent(
    shareTitle
  )}&url=${encodeURIComponent(shareUrl)}&via=&hashtags=`;

export const getFacebookUrl = ({ shareUrl }: GetShareUrlParams) =>
  `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    shareUrl
  )}`;

export const getLinkedInUrl = ({ shareUrl }: GetShareUrlParams) =>
  `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
    shareUrl
  )}`;

export const getShareEmailUrl = ({ shareTitle, shareUrl }: GetShareUrlParams) =>
  `mailto:?body=${shareUrl}&subject=${shareTitle}`;
